import DigitalMatter from '../../setups/DigitalMatter'

const DirectSetup = () => {
  return <DigitalMatter />
}

export default DirectSetup
